export const SENTRY_RELEASE: string | undefined = 'ea23cca3d908a964331b82e793b5600a062dd8a8';
